module.exports = __webpack_public_path__ + "img/meio-circulo.6548e471.png";